import React from "react";

import { ApolloProvider } from "react-apollo";
import client from "../../helpers/apollo-client";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

let DashboardNavDisplay = ({ data }) => {
    let { userCollections, userUploads } = data;
    let hasActiveIcons = userUploads && userUploads.hasApprovedUploads;

    let items = [];
    if (hasActiveIcons) {
        items.push(
            <li key="royalties">
                <a
                    href="#recent-royalties"
                    className="ui_dollar-sign-circle-filled"
                >
                    Royalties
                </a>
            </li>
        );
    }

    items.push(
        <li key="uploads">
            <a href="#user-uploads" className="ui_upload">
                Uploads
            </a>
        </li>
    );

    if (userCollections && userCollections.collections.length) {
        items.push(
            <li key="collections">
                <a href="#user-collections" className="ui_collections">
                    Collections
                </a>
            </li>
        );
    }

    items.push(
        <li key="kits">
            <a href="#user-kits" className="ui_kit">
                Kits
            </a>
        </li>
    );

    items.push(
        <li key="activity">
            <a href="#user-activity" className="ui_notifications">
                Activity
            </a>
        </li>
    );

    return (
        <nav className="section-nav">
            <ul id="dashboard-nav">{items}</ul>
        </nav>
    );
};

const query = gql`
    query HasCollections($userId: ID) {
        userCollections(limit: 1, userId: $userId) {
            collections {
                name
            }
        }
        userUploads {
            hasApprovedUploads
        }
    }
`;

DashboardNavDisplay = graphql(query, {
    options: props => ({
        variables: {
            userId: props.userId
        }
    })
})(DashboardNavDisplay);

let DashboardNav = ({ args }) => {
    let userId;
    if (args) {
        ({ userId } = args);
    }

    return (
        <ApolloProvider client={client}>
            <DashboardNavDisplay userId={userId} />
        </ApolloProvider>
    );
};

export default DashboardNav;
